<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <good-table-column-search
                :moduleapi="`${this.baseApi}/ledgermapping`"
                title="Ledger Mapping"
                :columns="columns"
                routerpath="/setup/addledgermapping"
                :formOptions="formOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodTableColumnSearch from '../../../components/GoodTableColumnSearch.vue'
import moment from 'moment'
import axios from '@/components/axios'
const baseApi = process.env.VUE_APP_APIENDPOINT

export default {
  components: {
    GoodTableColumnSearch
  },
  data () {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      columns: [
        {
          label: 'ID',
          field: 'id',
          filterOptions: {
            enabled: true,
            placeholder: 'Search ID'
          }
        },
        {
          label: 'Trading Account',
          field: 'tradingaccount',
          filterOptions: {
            enabled: true,
            placeholder: 'Search Trading Account'
          }
        },
        {
          label: 'CGST',
          field: 'cgst',
          filterOptions: {
            enabled: true,
            placeholder: 'Search CGST'
          }
        },
        {
          label: 'SGST',
          field: 'sgst',
          filterOptions: {
            enabled: true,
            placeholder: 'Search SGST'
          }
        },
        {
          label: 'IGST',
          field: 'igst',
          filterOptions: {
            enabled: true,
            placeholder: 'Search IGST'
          }
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      formOptions: {
        formTitle: `${
          this.$route.params.id ? 'Edit Ledger Mapping' : 'Add Ledger Mapping'
        }`,
        gridForm: true,

        submitRouterPath: '/setup/ledger-mapping',
        usersDropdown: true,
        method: 'post',
        action: 'add',
        url: `${baseApi}/ledgermapping`,
        inputFields: [
          {
            name: 'branch',
            value: 1,
            type: 'hidden'
          },
          {
            name: 'company',
            value: 1,
            type: 'hidden'
          },
          {
            name: 'active',
            value: 1,
            type: 'hidden'
          },
          {
            label: 'Trading Account',
            name: 'tradingaccount',
            value: '',
            type: 'dropdown',
            class: 'col-md-12',
            // url: "getUsers",
            required: true,
            options: []
          },
          {
            label: 'CSGT',
            name: 'cgst',
            value: '',
            type: 'dropdown',
            class: 'col-md-12',
            dropdownname: 'cgst',
            // url: "branch",
            required: true,
            options: []
          },
          {
            label: 'SGST',
            name: 'sgst',
            value: '',
            type: 'dropdown',
            class: 'col-md-12',
            dropdownname: 'sgst',
            required: true,
            options: []
          },
          {
            label: 'IGST',
            name: 'igst',
            value: '',
            type: 'dropdown',
            class: 'col-md-12',
            dropdownname: 'igst',
            required: true,
            options: []
          }
        ]
      }
    }
  },
  mounted () {
    const role = JSON.parse(localStorage.getItem('userData')).role
    if (role !== 'admin') {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
